<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ contractorIcon }}</md-icon>
            </div>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action method="post">
              <md-field>
                <label>Name</label>
                <md-input v-model="form.name" type="text" required></md-input>
              </md-field>
            </form>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button
              native-type="submit"
              @click.native.prevent="onSubmit"
              class="md-success md-sm"
              :disabled="hasSubmit"
              ><md-icon class="material-icons">check</md-icon>Submit</md-button
            >
            <md-button class="md-danger md-sm" @click="onCancel"
              ><md-icon class="material-icons">close</md-icon>Cancel</md-button
            >
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      hasSubmit: false,
      form: {
        name: undefined,
        contractorId: this.$route.params.contractorId
      }
    };
  },
  computed: {
    ...mapGetters({
      contractorIcon: "data-management-contractor/icon"
    })
  },
  methods: {
    onCancel() {
      this.hasSubmit = false;
      this.$router.go(-1);
    },
    onSubmit() {
      this.hasSubmit = true;
      this.$store
        .dispatch("data-management-contractor/createRegion", this.form)
        .then(data => {
          this.$router.push({
            name: "Contractor Region",
            params: { regionId: data }
          });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status === 400) {
            // handle validation error
            if (error.response.data.errors != undefined) {
              let validationErrorDictionary = error.response.data.errors;
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  errors.push("- " + validationErrorDictionary[fieldName]);
                }
              }
            } else {
              errors.push(error.response.data);
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    }
  }
};
</script>

<style></style>
